import useOpFindById from '@opsbase/react-gql-hooks/op/useOpFindById';
import Dialog from '@opsbase/web-dialogs/Dialog';
import DialogSize from '@opsbase/web-dialogs/Dialog/DialogSize';
import useParams from '@opsbase/web-nav/useParams';
import React from 'react';
import OpViewIssues from './OpViewIssues';
export function OpIssuesViewDialog() {
    const { id } = useParams();
    const { loading, data } = useOpFindById({ variables: { id } });
    return (React.createElement(Dialog, { size: DialogSize.X800_Y400, padded: false, white: true, loading: loading, title: data ? data.title : '' }, data && React.createElement(OpViewIssues, { op: data })));
}
export default OpIssuesViewDialog;
